import { createSlice, PayloadAction, createAsyncThunk  } from '@reduxjs/toolkit'
import { getOrderedState } from '../../../../utils/redux/reduxUtils'
import { activateScheduleNotification, deactivateScheduleNotification, deleteScheduleNotifications, getScheduleNotification, getScheduleNotifications, getUser, getUsers, updateScheduleNotification, UpdateScheduleNotificationBody } from '../../../../utils/requestsUtils/functionsRequests/user/userFunctions'
import { DeviceNotificationId, FrecuencyNotificationId } from '../../../../components/ScheduleNotification/CreateScheduleNotification/CreateScheduleNotificationForm/CreateScheduleNotificationForm'

export type DayOfWeek = "MON" | "TUE" | "WED" | "THU" | "FRI" | "SAT" | "SUN"

export type Schedule = {
    minutes:    number
    hour:       number
    dayOfMonth: number | string
    dayOfWeek:  string
    month:      number | string
    year:       number | string
}

export type ScheduleNotification = {
    id:                       string
    title:                    string
    bodyNotif:                string
    topic:                    string
    subject:                     string
    roleArnSchedule:          string
    scheduleCronExpression:   string
    schedule:                 Schedule
    userId:                   string
    activated:                number 
    frecuency:                FrecuencyNotificationId
    device:                   DeviceNotificationId
    creationDate:             string    
    counter:                  number
}




export const GetScheduleNotificationsThunk = createAsyncThunk(
    'scheduleNotificationsData/GetScheduleNotificationsThunk',
    async (activated: number) => {
        try { 

            const data = await getScheduleNotifications(activated)
            
            return {
                items: data.results,
                countActivated: data.countActivated,
                countDeactivated: data.countDeactivated,
                activated
            }
        } catch (error) {
            console.log("error", error)
            return {
              items: [] as ScheduleNotification[],
                countActivated: 0,
                countDeactivated: 0,
                activated
            }
        }
    }
)

export const GetScheduleNotificationThunk = createAsyncThunk(
    'scheduleNotificationsData/GetScheduleNotificationThunk',
    async (id: string) => {
        try { 

            const item = await getScheduleNotification(id)
            return {
              item
            }
        } catch (error) {
            console.log("error", error)
            return {
              item: undefined
            }
        }
    }
)

export const DeleteScheduleNotificationsThunk = createAsyncThunk(
    'scheduleNotificationsData/DeleteScheduleNotificationsThunk',
    async (id: string) => {
        try { 

            await deleteScheduleNotifications(id)
            
            return { id }
        } catch (error) {
            console.log("error", error)
            alert("Error")
            return { id }
        }
    }
)

export const UpdateScheduleNotificationsThunk = createAsyncThunk(
    'scheduleNotificationsData/UpdateScheduleNotificationsThunk',
    async ({ id, body }: { id: string, body: UpdateScheduleNotificationBody }) => {
        try { 

            await updateScheduleNotification(id, body)
            
            return { id, body }
        } catch (error) {
            console.log("error", error)
            alert("Error")
            return { id, body }
        }
    }
)

export const ActivateScheduleNotificationsThunk = createAsyncThunk(
    'scheduleNotificationsData/ActivateScheduleNotificationsThunk',
    async (id: string) => {
        try { 

            await activateScheduleNotification(id)
            
            return { id }
        } catch (error) {
            console.log("error", error)
            alert("Error")
            return { id }
        }
    }
)


export const DeactivateScheduleNotificationsThunk = createAsyncThunk(
    'scheduleNotificationsData/DeactivateScheduleNotificationsThunk',
    async (id: string) => {
        try { 

            await deactivateScheduleNotification(id)
            
            return { id }
        } catch (error) {
            console.log("error", error)
            alert("Error")
            return { id }
        }
    }
)


type InitialState = {
    items: ScheduleNotification[]
    scheduleNotification?: ScheduleNotification
    loadingContainer: boolean
    loadingInitalData: boolean
    orderDirection: boolean
    orderColumn: string
    activated:  number
    countActivated: number
    countDeactivated: number
}

const initialState: InitialState = {
    items: [] as ScheduleNotification[],
    loadingInitalData: false,
    scheduleNotification: undefined,
    //LastEvaluatedKey: "",
    loadingContainer: false,
    orderDirection: false,
    orderColumn: "",
    activated: 1,
    countActivated: 0,
    countDeactivated: 0
}

export const scheduleNotificationsDataSlice = createSlice({
  name: 'scheduleNotificationsData',
  initialState,
  reducers: {
        setAddScheduleNotificationReducer: (state, action: PayloadAction<ScheduleNotification>) => {
            /*
            state.modalName = "DeleteContractModal"

            const contractInfo = state.contracts.find((c) => c.countryName === action.payload.countryName)
            if(contractInfo)
                state.DeleteContractModalState = contractInfo
            */
            return state;
        },
        setUpdateScheduleNotificationReducer: (state, action: PayloadAction<{ id: string, body: UpdateScheduleNotificationBody }>) => {
            const { id, body } = action.payload

            if(state.scheduleNotification){
                state.scheduleNotification = {
                    ...state.scheduleNotification,
                    ...body,
                    activated: 1
                }
            }

            state.items = state.items.map((item) => {
                if(item.id === id){
                    return {
                        ...item,
                        ...body,
                        activated: 1
                    }
                }
                return item
            })
            return state;
        },
        resetScheduleNotificationItemReducer: (state) => {
            return {
                ...state,
                scheduleNotification: undefined
            }
        },
        resetScheduleNotificationsReducer: () => {
            return initialState
        }
  },

  extraReducers: (builder) => {
    builder.addCase(GetScheduleNotificationsThunk.fulfilled, (state, action: PayloadAction<{ items: ScheduleNotification[], activated: number, countActivated: number, countDeactivated: number}>) => {
        const { items, activated, countActivated, countDeactivated } = action.payload  
            state.activated = activated
            state.countActivated = countActivated
            state.countDeactivated = countDeactivated
            state.items = items
            state.loadingContainer = false
            return state
        }).addCase(GetScheduleNotificationsThunk.pending, (state, action: any) => {
            state.loadingContainer = true
            return state     
        }).addCase(GetScheduleNotificationsThunk.rejected, (state, action: any) => {
            const failState = {...initialState}
            failState.loadingContainer = false
            return failState
        })

        .addCase(GetScheduleNotificationThunk.fulfilled, (state, action: PayloadAction<{ item: ScheduleNotification | undefined }>) => {
        const { item } = action.payload  
            state.scheduleNotification = item
            state.loadingInitalData = false
            return state
        }).addCase(GetScheduleNotificationThunk.pending, (state, action: any) => {
            state.loadingInitalData = true
            return state     
        }).addCase(GetScheduleNotificationThunk.rejected, (state, action: any) => {
            const failState = {...initialState}
            failState.loadingInitalData = false
            return failState
        })

        .addCase(DeleteScheduleNotificationsThunk.fulfilled, (state, action: PayloadAction<{ id: string }>) => {

            const id = action.payload.id        
            state.items = state.items.filter((item) => item.id !== id)

            state.loadingContainer = false
            return state
        }).addCase(DeleteScheduleNotificationsThunk.pending, (state, action: any) => {
            state.loadingContainer = true
            return state     
        }).addCase(DeleteScheduleNotificationsThunk.rejected, (state, action: any) => {
            const failState = {...initialState}
            failState.loadingContainer = false
            return failState
        })

        .addCase(UpdateScheduleNotificationsThunk.fulfilled, (state, action: PayloadAction<{ id: string, body: UpdateScheduleNotificationBody }>) => {

                
            const { id, body } = action.payload

            if(state.scheduleNotification){
                state.scheduleNotification = {
                    ...state.scheduleNotification,
                    ...body,
                    activated: 1
                }
            }

            state.items = state.items.map((item) => {
                if(item.id === id){
                    return {
                        ...item,
                        ...body,
                        activated: 1
                    }
                }
                return item
            })
            

            state.loadingContainer = false
            return state
        }).addCase(UpdateScheduleNotificationsThunk.pending, (state, action: any) => {
            state.loadingContainer = true
            return state     
        }).addCase(UpdateScheduleNotificationsThunk.rejected, (state, action: any) => {
            const failState = {...initialState}
            failState.loadingContainer = false
            return failState
        })

      .addCase(ActivateScheduleNotificationsThunk.fulfilled, (state, action: PayloadAction<{ id: string }>) => {

            const { id } = action.payload

            if(state.scheduleNotification){
                state.scheduleNotification = {
                    ...state.scheduleNotification,
                    activated: 1
                }
            }

            state.items = state.items.map((item) => {
                if(item.id === id){
                    return {
                        ...item,
                        activated: 1
                    }
                }
                return item
            })
            

            state.loadingContainer = false
            return state
        }).addCase(ActivateScheduleNotificationsThunk.pending, (state, action: any) => {
            state.loadingContainer = true
            return state     
        }).addCase(ActivateScheduleNotificationsThunk.rejected, (state, action: any) => {
            const failState = {...initialState}
            failState.loadingContainer = false
            return failState
        })

        .addCase(DeactivateScheduleNotificationsThunk.fulfilled, (state, action: PayloadAction<{ id: string }>) => {

            const { id } = action.payload

            if(state.scheduleNotification){
                state.scheduleNotification = {
                    ...state.scheduleNotification,
                    activated: 0
                }
            }

            state.items = state.items.map((item) => {
                if(item.id === id){
                    return {
                        ...item,
                        activated: 0
                    }
                }
                return item
            })

            state.loadingContainer = false
            return state
        }).addCase(DeactivateScheduleNotificationsThunk.pending, (state, action: any) => {
            state.loadingContainer = true
            return state     
        }).addCase(DeactivateScheduleNotificationsThunk.rejected, (state, action: any) => {
            const failState = {...initialState}
            failState.loadingContainer = false
            return failState
        })
      
  },

});

export const {  
    resetScheduleNotificationsReducer,
    setAddScheduleNotificationReducer,
    resetScheduleNotificationItemReducer,
    setUpdateScheduleNotificationReducer
} = scheduleNotificationsDataSlice.actions

export default scheduleNotificationsDataSlice.reducer